import React from "react";
import { Link } from "react-router-dom";
import { FaDownload, FaFilePdf } from "react-icons/fa";
import Seo from "../components/Seo";
import { PAGE_SEO } from "../constants/seo";
import { useCatalogueContent } from "../hooks/useCatalogueContent";
import { resolveAssetUrl } from "../utils/assets";
import { CardGridSkeleton } from "../components/Skeleton";
import "./Catalogue.css";

const Catalogue = () => {
  const { content, loading } = useCatalogueContent();
  const { hero, items } = content;

  return (
    <main className="catalogue-page">
      <Seo {...PAGE_SEO.catalogue} />

      <section className="catalogue-hero">
        <div className="catalogue-hero-inner">
          <nav className="catalogue-breadcrumb" aria-label="Breadcrumb">
            <Link to="/">Home</Link>
            <span>/</span>
            <span>{hero.title || "Catalogue"}</span>
          </nav>
          {hero.subtitle && (
            <span className="catalogue-eyebrow">{hero.subtitle}</span>
          )}
          {hero.title && <h1>{hero.title}</h1>}
          {hero.description && <p>{hero.description}</p>}
        </div>
      </section>

      <section className="catalogue-grid-section">
        {loading ? (
          <CardGridSkeleton count={6} />
        ) : (
          <div className="catalogue-grid">
            {items.map((item, index) => {
              const cover = resolveAssetUrl(item.image) || item.image;
              const fileHref = resolveAssetUrl(item.fileUrl) || item.fileUrl;
              const hasFile = Boolean(fileHref);

              return (
                <article className="catalogue-card" key={item._id || index}>
                  <div className={`catalogue-card-media ${cover ? "" : "is-empty"}`}>
                    {cover ? (
                      <img src={cover} alt={item.title || "Catalogue cover"} />
                    ) : (
                      <FaFilePdf aria-hidden />
                    )}
                  </div>
                  <div className="catalogue-card-body">
                    <h2>{item.title}</h2>
                    {hasFile ? (
                      <a
                        className="catalogue-download"
                        href={fileHref}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <FaDownload />
                        {item.buttonText || "View & Download Here"}
                      </a>
                    ) : (
                      <span className="catalogue-download is-disabled">
                        Coming soon
                      </span>
                    )}
                  </div>
                </article>
              );
            })}
          </div>
        )}
      </section>
    </main>
  );
};

export default Catalogue;
